module.exports = __webpack_public_path__ + "img/zpxxbg.832e5d83.png";